<div class="marginTopHalfEm" [ngClass]="{'d-flex justify-content-between border-bottom':(screenType !== 'phone')}">
  <div class="" [ngClass]="{'border-right':(screenType !== 'phone')}">
    <div class="" [ngClass]="{'paddingHalfEm':(screenType !== 'phone')}">
      <div class="d-flex justify-content-between marginBottomHalfEm" >
        <button type="button" (click)="fireEvent('Administration', 'setSystemStatus', {message: message.value})" class="btn btn-secondary"><span class="fas fa-volume-up" aria-hidden="true"></span> Set System Message</button>
        <button type="button" (click)="fireEvent('Administration', 'setAccountStatus', {message: message.value})" class="btn btn-secondary"><span class="fas fa-volume-up" aria-hidden="true"></span> Set Account Message</button>
        <button type="button" (click)="fireEvent('Administration', 'setApplicationStatus', {message: message.value})" class="btn btn-secondary"><span class="fas fa-volume-up" aria-hidden="true"></span> Set Application Message</button>
        <button type="button" (click)="fireEvent('Administration', 'logMessage', {message: message.value, level: 'INFO'})" class="btn btn-secondary"><span class="fas fa-pencil-alt" aria-hidden="true"></span> Log Message</button>
      </div>
      <div>
        Message: <wackadoo-field-string [f]="message" [mode]="'write'" [size]="messageSize"></wackadoo-field-string>
      </div>
      <div class="d-flex justify-content-between marginTop6 marginBottomHalfEm" >
        <button type="button" (click)="fireEvent('Administration', 'clearSystemStatus')" class="btn btn-secondary"><span class="fas fa-volume-mute" aria-hidden="true"></span> Clear System Message</button>
        <button type="button" (click)="fireEvent('Administration', 'clearAccountStatus')" class="btn btn-secondary"><span class="fas fa-volume-mute" aria-hidden="true"></span> Clear Account Message</button>
        <button type="button" (click)="fireEvent('Administration', 'clearApplicationStatus')" class="btn btn-secondary"><span class="fas fa-volume-mute" aria-hidden="true"></span> Clear Application Message</button>
      </div>
    </div>
    <div class="border-top" [ngClass]="{'paddingHalfEm':(screenType !== 'phone')}">
      <div class="d-flex justify-content-between marginTop6 marginBottomHalfEm" >
        <button type="button" (click)="fireEvent('Administration', 'getStatistics')" class="btn btn-secondary">Get Statistics</button>
        <button type="button" (click)="fireEvent('Administration', 'getStatus')" class="btn btn-secondary">Get Status</button>
        <button type="button" (click)="runServerMonitor()" class="btn btn-secondary">Run ServerMonitor</button>
      </div>
    </div>
  </div>
  <div class="" [ngClass]="{'border-left':(screenType !== 'phone')}">
    <div class="" [ngClass]="{'paddingHalfEm':(screenType !== 'phone')}">
      <div class="d-flex justify-content-between marginTop6 marginBottomHalfEm" >
        <button type="button" (click)="fireEvent('SearchService', 'runNow')" class="btn btn-secondary">Search Service</button>
        <button type="button" (click)="fireEvent('SearchService', 'forceIndexRebuild')" class="btn btn-secondary">Search Update</button>
        <button type="button" (click)="fireEvent('SearchService', 'forceCompleteIndexRebuild')" class="btn btn-secondary">Search Rebuild</button>
      </div>
    </div>
    <div class="border-top" [ngClass]="{'paddingHalfEm':(screenType !== 'phone')}">
      <div class="d-flex justify-content-between marginTop6 marginBottomHalfEm" >
        <button type="button" (click)="fireEvent('Administration', 'getVersion')" class="btn btn-secondary">Get Version</button>
        <button type="button" (click)="fireEvent('Administration', 'getLinks')" class="btn btn-secondary">Get Links</button>
        <button type="button" (click)="fireEvent('Administration', 'getClientAPI')" class="btn btn-secondary">Get API</button>
        <button type="button" (click)="bounceSocketListener()" class="btn btn-secondary">Bounce Socket Listener</button>
      </div>
    </div>
  </div>
</div>
<div class="card"  *ngIf="(resources.length > 0) || (messages.length > 0)">
  <div class="card-body scrollable"
        wackadooMaximizeContentHeight
        maxHeightThingBelowSelector=".wackadoo-footer"
        [maxHeightFudgeFactor]="-12"
  >
    <div *ngIf="resources.length > 0">
      <ng-container *ngIf="screenType !== 'phone'">
        <table class="marginBottomQuarterEm">
          <tr class="border-bottom" *ngFor="let r of resources; let idx = index">
            <td class="right top">
              <div class="bold">{{ r.getName() }}</div>
              <div class="italic smallish" *ngIf="r.getClassName()">({{ r.getClassName() }})</div>
            </td>
            <td>
              <div class="d-flex flex-wrap top marginBottomQuarterEm" >
                <div class="border-left border-right paddingLeftHalfEm paddingRightHalfEm" *ngFor="let f of r.fields" >
                  <div class="underline smallish">
                    {{ f.name }} 
                  </div>
                  <div>
                    <wackadoo-field [f]="f" [mode]="'read'"></wackadoo-field>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </table>
      </ng-container>
      <ng-container *ngIf="screenType === 'phone'">
        <div class="border-bottom" *ngFor="let r of resources; let idx = index">
          <div>
            <div class="bold">{{ r.getName() }}</div>
            <div class="italic smallish" *ngIf="r.getClassName()">({{ r.getClassName() }})</div>
          </div>
          <table class="marginBottomQuarterEm">
            <tr class="top" *ngFor="let f of r.fields; let h = index;">
              <td  class="underline smallish right">
                {{ f.name }}
              </td>
              <td>
                <wackadoo-field [f]="f" [mode]="'read'"></wackadoo-field>
              </td>
            </tr>
          </table>
        </div>
      </ng-container>
    </div>
    <div *ngIf="messages.length > 0">
      <div *ngFor="let m of messages; let idx = index">
        {{ m }}
      </div>
    </div>
  </div>
</div>
